/* eslint-disable camelcase */
// camel case is disabled because google's format doesn't use it
'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["streetAddressLine1", "region"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var _require = require('./CountryList.js'),
  getLongFromShortCode = _require.getLongFromShortCode,
  getShortFromLongCode = _require.getShortFromLongCode;
function containsSpecialChars(string) {
  var specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,<>\/?~]/;
  // eslint-disable-next-line no-control-regex
  var nonStandardLatin = /[^\x00-\x7F]+/;
  return specialChars.test(string) || nonStandardLatin.test(string);
}

/**
 * Parse Google's address components object into something that's easier to work with
 * @param {Object} addressComponents - The google address_components object
 * @param {String} adr_address - The google adr_address string
 * @return {Object} An object with the address components mapped in a more convenient to read way
 */
function parseAddressComponents(addressComponents, adr_address) {
  var fannedAddressComponents = {};
  // eslint-disable-next-line complexity
  addressComponents.forEach(function (component) {
    var keyName = component.types[0];
    if (keyName === 'route' || keyName === 'country' || keyName === 'administrative_area_level_1' || keyName === 'administrative_area_level_3') {
      if (containsSpecialChars(component.short_name) && containsSpecialChars(component.long_name)) {
        fannedAddressComponents[keyName] = component.short_name;
      } else if (containsSpecialChars(component.short_name)) {
        fannedAddressComponents[keyName] = component.long_name;
      } else {
        fannedAddressComponents[keyName] = component.short_name;
      }
    } else {
      fannedAddressComponents[keyName] = component.long_name;
    }
  });
  fannedAddressComponents.adr_address = adr_address;
  return fannedAddressComponents;
}

/**
 * Parse Google's address components object into something that's easier to work with
 * @param {Object} fannedAddressComponents - Address components as formatted by parseAddressComponents()
 * @return {Object} An address object that works with EG services
 */
// eslint-disable-next-line complexity
function updateAddressFields(fannedAddressComponents) {
  var street_number = fannedAddressComponents.street_number,
    route = fannedAddressComponents.route,
    locality = fannedAddressComponents.locality,
    postal_code = fannedAddressComponents.postal_code,
    subpremise = fannedAddressComponents.subpremise,
    premise = fannedAddressComponents.premise,
    postal_town = fannedAddressComponents.postal_town,
    neighborhood = fannedAddressComponents.neighborhood,
    sublocality_level_4 = fannedAddressComponents.sublocality_level_4,
    sublocality_level_3 = fannedAddressComponents.sublocality_level_3,
    sublocality_level_2 = fannedAddressComponents.sublocality_level_2,
    sublocality_level_1 = fannedAddressComponents.sublocality_level_1,
    administrative_area_level_1 = fannedAddressComponents.administrative_area_level_1,
    administrative_area_level_2 = fannedAddressComponents.administrative_area_level_2,
    administrative_area_level_3 = fannedAddressComponents.administrative_area_level_3,
    administrative_area_level_4 = fannedAddressComponents.administrative_area_level_4,
    adr_address = fannedAddressComponents.adr_address;
  var address = {};
  // TODO: This fallback seems like it might be wrong according to what comes back from google,
  // but the Vrbo parsing never used adr_address, so leaving it as is for the Shenzen team
  // "adr_address":"<span class=\"street-address\">11800 Domain Blvd</span>, <span class=\"...
  var streetAddFallback = adr_address ? adr_address.substring(0, adr_address.indexOf('<span class="') - 2) : '';
  address.postalCode = postal_code;
  address.streetAddressLine1 = "".concat(street_number || '', " ").concat(route || '');
  address.city = locality || administrative_area_level_1;
  var regionWithAreaLevel2 = ['ES', 'IT', 'FR'];
  address.region = regionWithAreaLevel2.indexOf(fannedAddressComponents.country) !== -1 ? administrative_area_level_2 : administrative_area_level_1;
  switch (fannedAddressComponents.country) {
    case 'CA':
    case 'US':
    case 'GB':
    case 'AU':
      address.city = locality || sublocality_level_1 || postal_town;
      break;
    case 'RU':
      address.city = administrative_area_level_1 || locality;
      address.region = '';
      break;
    case 'ES':
    case 'IT':
    case 'AT':
    case 'DE':
    case 'TR':
    case 'PT':
      address.streetAddressLine1 = "".concat(route || '', " ").concat(street_number || '');
      break;
    case 'FR':
      address.streetAddressLine1 = "".concat(street_number || '', " ").concat(route || '', " ").concat(subpremise || '', " ").concat(premise || '');
      if (address.city.indexOf('Paris-') !== -1) {
        address.city = 'Paris';
      }
      break;
    case 'MX':
      address.streetAddressLine1 += " ".concat(sublocality_level_1 || '');
      break;
    case 'CN':
      address.streetAddressLine1 += " ".concat(sublocality_level_1 || '');
      break;
    case 'HK':
      address.streetAddressLine1 += ", ".concat(locality || '');
      address.region = '';
      break;
    case 'TH':
      if (neighborhood && neighborhood.length + address.streetAddressLine1.length <= 40) {
        address.streetAddressLine1 += neighborhood ? ", ".concat(neighborhood || '') : '';
      }
      if (sublocality_level_2 && sublocality_level_2.length + address.streetAddressLine1.length <= 40) {
        address.streetAddressLine1 += sublocality_level_2 ? ", ".concat(sublocality_level_2 || '') : '';
      }
      break;
    case 'VN':
      address.streetAddressLine1 += " ".concat(sublocality_level_1 || '', " ").concat(administrative_area_level_2 || '');
      address.region = '';
      break;
    case 'KR':
      address.streetAddressLine1 = sublocality_level_4 ? "".concat(premise || '', " ").concat(sublocality_level_4, " ").concat(sublocality_level_1 || '') : "".concat(premise || '', " ").concat(sublocality_level_2 || '', " ").concat(sublocality_level_1 || '');
      break;
    case 'JP':
      address.streetAddressLine1 += sublocality_level_3 ? "".concat(sublocality_level_3.split(' ')[0], "-") : '';
      address.streetAddressLine1 += sublocality_level_4 ? "".concat(sublocality_level_4, "-") : '';
      address.streetAddressLine1 += premise ? premise : '';
      address.streetAddressLine1 += " ".concat(sublocality_level_2 || '', " ").concat(sublocality_level_1 || '');
      break;
    case 'TW':
      address.streetAddressLine1 = "".concat(administrative_area_level_3 || '', " ").concat(route || '', " ").concat(street_number || '');
      break;
    case 'BR':
      address.streetAddressLine1 = route && street_number ? "".concat(route || '', ", ").concat(street_number || '') : route || '';
      address.city = sublocality_level_1 ? "".concat(sublocality_level_1 || '', " ").concat(administrative_area_level_2 || '') : administrative_area_level_4 || administrative_area_level_2;
      break;
    case 'IN':
      address.streetAddressLine1 = "".concat(street_number || '', " ").concat(route || '', " ").concat(premise || '', " ").concat(sublocality_level_3 || '', " ").concat(sublocality_level_2 || '', " ").concat(sublocality_level_1 || '');
      if (address.streetAddressLine1.length > 40) {
        address.streetAddressLine1 = "".concat(street_number || '', " ").concat(route || '', " ").concat(premise || '', " ").concat(sublocality_level_2 || '', " ").concat(sublocality_level_1 || '');
      }
      if (address.streetAddressLine1.length > 40) {
        address.streetAddressLine1 = "".concat(street_number || '', " ").concat(route || '', " ").concat(premise || '', " ").concat(sublocality_level_1 || '');
      }
      if (address.streetAddressLine1.length > 40) {
        address.streetAddressLine1 = "".concat(street_number || '', " ").concat(route || '', " ").concat(premise || '');
      }
      if (address.streetAddressLine1.length > 40) {
        address.streetAddressLine1 = "".concat(street_number || '', " ").concat(route || '');
      }
      break;
    default:
      address.streetAddressLine1 = "".concat(street_number || '', " ").concat(route || '');
  }
  if (!address.streetAddressLine1.trim()) {
    address.streetAddressLine1 = streetAddFallback;
  }
  address.streetAddressLine1 = address.streetAddressLine1.trim();
  return address;
}

/**
 * Turn google's address object into something that works with EG services
 * @param {Object} address - The google address object
 * @return {Object} An address object compatible with EG services
 */
function getEgCompatibleAddress(address) {
  var fanned = parseAddressComponents(address.address_components, address.adr_address);
  return _objectSpread(_objectSpread({}, updateAddressFields(fanned)), {}, {
    // EG services take a long form country
    country: getLongFromShortCode(fanned.country)
  });
}

/**
 * Turn google's address object into something that works with Vrbo services
 * @param {Object} address - The google address object
 * @return {Object} An address object compatible with Vrbo services
 */
function getVrboCompatibleAddress(address) {
  var fanned = parseAddressComponents(address.address_components, address.adr_address);
  var fields = updateAddressFields(fanned);
  // eslint-disable-next-line no-unused-vars
  var streetAddressLine1 = fields.streetAddressLine1,
    region = fields.region,
    rest = _objectWithoutProperties(fields, _excluded);
  return _objectSpread(_objectSpread({}, rest), {}, {
    // Rename to vrbo address field names
    address1: streetAddressLine1,
    stateProvince: region,
    // Vrbo services take the short form of country that we get from google
    country: fanned.country
  });
}
module.exports = {
  parseAddressComponents: parseAddressComponents,
  updateAddressFields: updateAddressFields,
  getEgCompatibleAddress: getEgCompatibleAddress,
  getVrboCompatibleAddress: getVrboCompatibleAddress,
  getLongFromShortCode: getLongFromShortCode,
  getShortFromLongCode: getShortFromLongCode
};